<angular-editor (focus)="onFocus()"
                (blur)="onBlur()"
                (ngModelChange)="onModelChanged($event)"
                [(ngModel)]="model"
                [config]="config"></angular-editor>
